var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import cn from 'classnames';
import s from './styles.module.css.json';
export function SwitchInput(_a) {
    var _b;
    var className = _a.className, value = _a.value, disabled = _a.disabled, onClick = _a.onClick, onChange = _a.onChange, onKeyDown = _a.onKeyDown, restProps = __rest(_a, ["className", "value", "disabled", "onClick", "onChange", "onKeyDown"]);
    function triggerChange(newValue, event) {
        if (!disabled && onChange) {
            onChange(newValue, event);
        }
    }
    function onInternalKeyDown(e) {
        if (e.key === 'ArrowLeft') {
            triggerChange(false, e);
        }
        else if (e.key === 'ArrowRight') {
            triggerChange(true, e);
        }
        onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(e);
    }
    function onInternalClick(e) {
        triggerChange(!value, e);
        onClick === null || onClick === void 0 ? void 0 : onClick(e);
    }
    var switchClassName = cn(s['switchInput'], className, (_b = {},
        _b[s['switchInput__checked']] = value,
        _b[s['switchInput__disabled']] = disabled,
        _b));
    return (React.createElement("button", __assign({}, restProps, { type: "button", role: "switch", "aria-checked": value, disabled: disabled, className: switchClassName, onKeyDown: onInternalKeyDown, onClick: onInternalClick }),
        React.createElement("span", { className: s['switchInput__inner'] })));
}
//# sourceMappingURL=index.js.map